<template>
  <div class="result-card" v-if="infoData.status != undefined ">
    <div class="result-card-title">
      {{ infoData.status == '2' ? '反馈建议' : '处理结果' }}
    </div>
    <div class="result-card-info" v-if="infoData.status == '1'">
      {{ infoData.dealResult }}
    </div>
    <div class="result-card-feedback" v-else>
      <z-row>
        <z-col span='5'>平台反馈</z-col>
        <z-col span='19'>{{infoData.feedback}}</z-col>
      </z-row>
      <z-row>
        <z-col span='5'>举报建议</z-col>
        <z-col span='19'>{{suggest.join('')}}</z-col>
      </z-row>
      <z-button icon="https://pic4.zhuanstatic.com/zhuanzh/81589478-67e5-4124-b26b-f153d3df7b81.png" text="上传补充凭证" size="small" @click="goToSupply"></z-button>
    </div>
    <z-action-picker
      title="补充证据"
      v-model="showModal"
      @confirm="onConfirm"
      :btn-props="btnProps"
      height="50vh"
    >
    <div class="content">
      <p v-for="(item,index) in suggest" :key="index">
        {{item}}
      </p>
      <z-field
        darkBg
        v-model="message"
        type="textarea"
        placeholder="请描述事情经过"
        rows="3"
        :maxlength="300"
        count-word
      ></z-field>
      <p>如有其他证据，请上传相应凭证(图片/视频)</p>
      <div class="upload">
        <z-upload
          v-model="files"
          ref="upload"
          accept="image/*, video/*"
          :max="9"
          btnUploadInfo="上传凭证"
          dropOriginFile
          :draggable="false"
          @file-click="fileClick"
          @file-success="fileSuccess"
          @file-removed="fileRemove"
          @files-added="filesAdded"
          >
        </z-upload>
      </div>
    </div>
    </z-action-picker>
  </div>
</template>
<script>
import native from '@zz-common/native-adapter'
import { newReportSupplySubmit } from '@api/resourceApi'
import { Row, Col, Button, ActionPicker, Field, Upload, ImagePreview } from '@zz-common/zz-ui';
export default {
  name: 'ResultCard',
  props: {
    infoData: {
      default: () => {}
    }
  },
  data() {
    return {
      showModal: false,
      files: [],
      message: '',
      uploading: false
    }
  },
  components: {
    'z-row': Row,
    'z-col': Col,
    'z-button': Button,
    'z-action-picker': ActionPicker,
    'z-field': Field,
    'z-upload': Upload
  },
  computed: {
    suggest() {
      return this.infoData.suggest || []
    },
    btnProps() {
      if (this.uploading) {
        return {
          disabled: true
        }
      }
      if (this.message.length > 5 && this.files.length > 0) return {}
      return {
        disabled: true
      }
    }
  },
  inject: ['id', 'toUid'],
  methods: {
    goToSupply() {
      this.showModal = true
    },
    onConfirm() {
      newReportSupplySubmit({
        pics: JSON.stringify(this.files2PicAndVideo(this.files)),
        content: this.message,
        reportId: this.id,
        reportSource: '10'
      }).then(_res => {
        this.$toast('提交成功')
        native.close()
      })
    },
    files2PicAndVideo(array = []) {
      return array.map(t => {
        if (/image/g.test(t.type)) {
          return t.url
        }
        if (/video/g.test(t.type)) {
          return {
            picUrl: t.response,
            videoUrl: t.url
          }
        }
        return ''
      })
    },
    fileClick(data) {
      console.log('看看对象', data)
      if (/image/g.test(data.type)) {
        ImagePreview({
          images: [data.url],
          showClose: true,
          showLoading: true
        });
      }
      if (/video/g.test(data.type)) {
        ImagePreview({
          videoVos: [{
            auto: false,
            muteBtn: false,
            controls: true,
            videoUrl: data.url
          }],
          startPosition: 0,
          withVideo: true,
          showClose: true,
          adaptHeight: true,
          adaptApp: true,
          showLoading: true
        });
      }
    },
    filesAdded() {
      this.uploading = true
    },
    fileSuccess() {
      if (this.$refs.upload.isComplete()) {
        this.uploading = false
      }
    },
    fileRemove() {
      if (this.$refs.upload.isComplete()) {
        this.uploading = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
 @import 'index.less';
</style>